function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

// Share functionality
function initShareButton() {
  const shareButton = document.getElementById('shareButton');
  if (!shareButton) return;

  shareButton.addEventListener('click', async function () {
    const url = this.dataset.url;
    const title = this.dataset.title;
    const shareText = document.getElementById('shareText');

    // Check if device is mobile and Web Share API is supported
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    if (isMobile && navigator.share) {
      try {
        await navigator.share({
          title: title,
          url: url
        });
      } catch (err) {
        // User cancelled or error occurred, fallback to clipboard
        copyToClipboard(url);
        updateShareText(shareText);
      }
    } else {
      // Desktop: always copy to clipboard
      copyToClipboard(url);
      updateShareText(shareText);
    }
  });
}

function copyToClipboard(text) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text).then(() => {
      // Copy successful
    }).catch(() => {
      // Fallback for older browsers
      fallbackCopyToClipboard(text);
    });
  } else {
    fallbackCopyToClipboard(text);
  }
}

function fallbackCopyToClipboard(text) {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.left = '-999999px';
  textArea.style.top = '-999999px';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand('copy');
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }

  document.body.removeChild(textArea);
}

function updateShareText(shareTextElement) {
  if (!shareTextElement) return;

  shareTextElement.textContent = 'link copied!';

  // Reset text back to "Share" after 3 seconds
  setTimeout(() => {
    shareTextElement.textContent = 'share';
  }, 3000);
}


// Header scroll behaviour:
// - All pages: background fades in/out based on scroll position
// - Homepage only: logo also fades in (handled by CSS .homepage class)
function initHeaderScroll() {
  const header = document.getElementById('site-header');
  if (!header) return;

  const isTransparent = header.classList.contains('site-header--transparent');
  const showThreshold = isTransparent ? window.innerHeight * 0.25 : 80;

  let ticking = false;

  // Apply scrolled state immediately if already past threshold on load
  if (window.scrollY > showThreshold) {
    header.classList.add('scrolled');
  }

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      if (window.scrollY > showThreshold) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      ticking = false;
    });
  }, { passive: true });
}

// Initialize share functionality when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  initShareButton();
  initHeaderScroll();

  // Intercept /pages/how-it-works links → scroll to #how-it-works section
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href*="/pages/how-it-works"]');
    if (!link) return;
    e.preventDefault();
    const target = document.getElementById('how-it-works');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      // Not on homepage — navigate there with anchor
      window.location.href = '/#how-it-works';
    }
  });
});